import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import scrollIntoView from "scroll-into-view-if-needed";
import { useStore } from "effector-react";
import clsx from "clsx";

import { URLS } from "src/shared/library/router";
import { $isLoggedIn, logout } from "src/entities/user/model";
import { $reports } from "src/screens/protected/history-screen/model";

export const Header = () => {
  const location = useLocation();

  const reportsCount = useStore($reports).length;

  const isLoggedIn = useStore($isLoggedIn);

  const [isNavOpen, setIsNavOpen] = useState(false);

  const handleScroll = () => {
    const elem = document.getElementById("what_scroll");

    if (elem) {
      scrollIntoView(elem, {
        behavior: "smooth",
        block: "start",
      });
    }
  };

  useEffect(() => {
    setIsNavOpen(false);
  }, [location.pathname]);

  return (
    <header className="bg-light-blue w-full relative">
      <div className="inner-container px-4 md:px-2 flex items-center justify-between py-3">
        <NavLink
          to={URLS.HOME}
          className="w-full ml-9 md:ml-0 flex md:inline-flex items-center justify-center md:justify-start w-fit"
        >
          <div className="inline-flex items-center">
            <img src="/images/logo.svg" alt="НАЗВА" width="40" height="40" />
            <h1 className="ml-[10px] text-high-contrast font-medium text-body md:text-[20px] leading-6">
              Сервіс протимінної діяльності ДСНС
            </h1>
          </div>
        </NavLink>

        <div className="hidden md:flex items-center">
          {isLoggedIn && (
            <>
              <NavLink
                to="/"
                className={({ isActive }) =>
                  clsx("text-primary-light mr-8 hidden md:block text-body", {
                    underline: isActive,
                  })
                }
              >
                Головна
              </NavLink>

              {reportsCount > 0 && (
                <NavLink
                  className={({ isActive }) =>
                    clsx("text-primary-light mr-8 hidden md:block text-body", {
                      underline: isActive,
                    })
                  }
                  to="/history"
                >
                  Історія викликів
                </NavLink>
              )}

              <span
                className="hidden md:block text-input-error text-body mr-8 cursor-pointer"
                onClick={() => logout()}
              >
                Вийти
              </span>
            </>
          )}
          {!isLoggedIn && (
            <>
              <span
                onClick={handleScroll}
                className="mr-4 text-body text-black font-medium cursor-pointer"
              >
                Що робити з вибухівкою?
              </span>

              <div className="h-2 w-px bg-[#C5C5C5] mr-4" />

              <a
                href="https://dsns.gov.ua/map-demining"
                target="_blank"
                rel="noreferrer nofollow"
                className="mr-6 text-body text-black font-medium"
              >
                Інформація щодо розмінування
              </a>
              <NavLink to="/login" className="flex items-center text-body">
                <img
                  src="/images/account_circle.svg"
                  alt="account"
                  width="32"
                  height="32"
                  className="mr-2"
                />
                Увійти
              </NavLink>
            </>
          )}
        </div>

        <nav className="block md:hidden">
          <section className="ml-4 flex lg:hidden">
            <div
              className={clsx(
                "space-y-1 absolute left-[15px] top-1/2 -translate-y-1/2",
                {
                  "opacity-0": isNavOpen,
                }
              )}
              onClick={() => setIsNavOpen((prev) => !prev)} // toggle isNavOpen state on click
            >
              <span className="block h-0.5 w-6 bg-gray-600" />
              <span className="block h-0.5 w-6 bg-gray-600" />
              <span className="block h-0.5 w-6 bg-gray-600" />
            </div>

            <div
              className={
                isNavOpen
                  ? "shadow-base absolute w-full z-[1100] top-[64px] left-0 flex flex-col bg-white"
                  : "hidden"
              }
            >
              <div
                className="absolute -top-[72px] left-0 px-3 pt-5"
                onClick={() => setIsNavOpen(false)} // change isNavOpen state to false to close the menu
              >
                <svg
                  className="h-8 w-8 text-gray-600"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </div>
              <ul className="MENU-LINK-MOBILE-OPEN flex flex-col items-center text-body">
                <li className="border-b border-neutral-5 py-4 text-primary-light w-full px-[15px]">
                  <NavLink to="/create">Повідомити</NavLink>
                </li>

                <li className="border-b border-neutral-5 py-4 text-primary-light w-full px-[15px]">
                  <a
                    href="https://dsns.gov.ua/map-demining"
                    target="_blank"
                    rel="noreferrer nofollow"
                  >
                    Інформація щодо розмінування
                  </a>
                </li>

                {isLoggedIn && (
                  <>
                    <li className="text-primary-light py-4 px-[15px] w-full">
                      <NavLink to="/">Головна</NavLink>
                    </li>
                    {reportsCount > 0 && (
                      <li className="text-primary-light py-4 px-[15px] w-full">
                        <NavLink to="/history">Історія викликів</NavLink>
                      </li>
                    )}
                    <li className="text-primary-light py-4 w-full px-[15px]">
                      <span className="cursor-pointer" onClick={() => logout()}>
                        Вихід
                      </span>
                    </li>
                  </>
                )}

                {!isLoggedIn && (
                  <li className="border-b border-neutral-5 py-4 text-primary-light w-full px-[15px]">
                    <NavLink to="/login">Увійти</NavLink>
                  </li>
                )}
              </ul>
            </div>
          </section>
        </nav>
      </div>
    </header>
  );
};
